import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Container, Typography, Button, Paper, Grid } from '@mui/material';

const Quiz = ({ quizData, setView }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);

  const handleAnswerClick = (isCorrect) => {
    if (isCorrect) {
      setScore(score + 1);
    }

    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < quizData.questions.length) {
      setCurrentQuestion(nextQuestion);
    } else {
      setShowResult(true);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
    >
      <Container maxWidth="md">
        <Paper className="glass-card">
          {showResult ? (
            <div>
              <Typography variant="h4" component="h2" gutterBottom>
                Your Score: {score} out of {quizData.questions.length}
              </Typography>
              <Typography variant="h6" component="p" gutterBottom>
                {quizData.results[score]}
              </Typography>
              <Button variant="contained" onClick={() => setView('home')}>
                Back to Home
              </Button>
            </div>
          ) : (
            <div>
              <Typography variant="h4" component="h2" gutterBottom>
                {quizData.questions[currentQuestion].question}
              </Typography>
              <Grid container spacing={2} justifyContent="center">
                {quizData.questions[currentQuestion].answers.map((answer, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <motion.div
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={() => handleAnswerClick(answer.isCorrect)}
                      >
                        {answer.text}
                      </Button>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </div>
          )}
        </Paper>
      </Container>
    </motion.div>
  );
};

export default Quiz;
